import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer } from '@mui/material';

// third-party
import PerfectScrollbar from 'react-perfect-scrollbar';

// project imports
import { drawerWidth } from 'metadata/constant';
import MenuList from './MenuList';

// ==============================|| SIDEBAR DRAWER ||============================== //

const Sidebar = ({ drawerOpen, drawerToggle, handleDrawerClose, window }) => {
    const theme = useTheme();

    const drawer = (
        <>
            <PerfectScrollbar
                component="div"
                style={{
                    height: 'calc(100vh - 88px)',
                    paddingLeft: '16px',
                    paddingRight: '16px'
                }}
            >
                <MenuList />
            </PerfectScrollbar>
        </>
    );

    return (
        <Box
            component="nav"
            sx={{
                width: {
                    sm: drawerWidth
                },
                flexShrink: { sm: 0 }
            }}
            aria-label="mailbox folders"
        >
            <Drawer
                variant="temporary"
                open={drawerOpen}
                onClose={handleDrawerClose}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, background: theme.palette.bgd.background }
                }}
                keepMounted
            >
                {drawer}
            </Drawer>
            <Drawer
                variant="permanent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        width: drawerWidth,
                        background: theme.palette.bgd.background,
                        color: theme.palette.text.primary,
                        borderRight: 'none',
                        top: '100px'
                    }
                }}
                open
            >
                {drawer}
            </Drawer>
        </Box>
    );
};

Sidebar.propTypes = {
    drawerOpen: PropTypes.bool,
    drawerToggle: PropTypes.func,
    window: PropTypes.object
};

export default Sidebar;
